<div class="help-page">
  <div class="help-header">
    <h1>Hilfe</h1>
    <p class="help-intro">
      Hier finden Sie Erklärungen zu den Bereichen von ParkraumPlus, auf die Sie Zugriff haben: was sie tun,
      welche Status es gibt und was die wichtigsten Schaltflächen bewirken. Nutzen Sie die Suche, um schnell ein Thema zu finden.
    </p>

    <!-- Search bar -->
    <div class="help-search">
      <svg class="help-search-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
           stroke-width="2" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round"
              d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" />
      </svg>
      <input
        type="text"
        class="help-search-input"
        [(ngModel)]="searchTerm"
        placeholder="Hilfe durchsuchen ..."
        aria-label="Hilfe durchsuchen" />
      <button *ngIf="searchTerm" type="button" class="help-search-clear" (click)="clearSearch()" aria-label="Suche leeren">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>

  <!-- Loading / error states -->
  <p *ngIf="isLoading" class="help-message">Hilfe wird geladen ...</p>
  <p *ngIf="loadError" class="help-message help-message--error">
    Die Hilfe-Inhalte konnten nicht geladen werden.
  </p>

  <!-- Accordion -->
  <div *ngIf="!isLoading && !loadError" class="help-accordion">
    <div *ngFor="let page of filteredPages; trackBy: trackById" class="help-panel">
      <button type="button" class="help-panel-header" (click)="toggle(page.id)" [attr.aria-expanded]="isExpanded(page)">
        <span class="help-panel-title">{{ page.title }}</span>
        <svg class="help-panel-chevron" [class.is-open]="isExpanded(page)" xmlns="http://www.w3.org/2000/svg"
             fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
      </button>

      <div class="help-panel-body" [class.hidden]="!isExpanded(page)">
        <p class="help-summary">{{ page.summary }}</p>

        <div *ngFor="let section of page.sections" class="help-section">
          <h4 class="help-section-heading">{{ section.heading }}</h4>
          <dl class="help-deflist">
            <div *ngFor="let item of section.items" class="help-deflist-row">
              <dt class="help-term">{{ item.term }}</dt>
              <dd class="help-desc">{{ item.description }}</dd>
            </div>
          </dl>
        </div>
      </div>
    </div>

    <p *ngIf="filteredPages.length === 0 && hasSearch" class="help-message">
      Keine Ergebnisse für &bdquo;{{ searchTerm }}&ldquo;.
    </p>
    <p *ngIf="filteredPages.length === 0 && !hasSearch && visiblePages.length === 0" class="help-message">
      Für Ihre Rolle sind derzeit keine Hilfethemen verfügbar.
    </p>
  </div>
</div>
